export const ZIP_LENGTH = 5;
export const ZIP_VALIDATION_PATTERN = String.raw`^\d{${ZIP_LENGTH}}$`;
export const ZIP_REGEX = new RegExp(ZIP_VALIDATION_PATTERN);
